// extracted by mini-css-extract-plugin
export var container = "components-home-__Callout-module___container";
export var title = "components-home-__Callout-module___title";